@media screen {
    .container {
        display: grid;
        grid-template-columns: 1fr 275px;
        padding: 16px;
        gap: 16px;
    }
}

@media screen and (max-width: 1488px) {
    .container {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }
}
